export const link = 'https://bnnvara.nl/pagina/algemene-voorwaarden';
